require("!!/root/xmpp-web/node_modules/script-loader/addScript.js")(require("!!/root/xmpp-web/node_modules/script-loader/node_modules/raw-loader/index.js!/root/xmpp-web/node_modules/strophe/strophe.js"))


/*****************
 ** WEBPACK FOOTER
 ** ./~/script-loader!./~/strophe/strophe.js
 ** module id = 2
 ** module chunks = 0
 **/